module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fhZAa"))).then(() => parcelRequire('hEqeo'));